/** Department slug used in routes — must match ApplicationRedirectHandlers. */
export const getDepartmentNameByPermitId = (permitId: number): string => {
  switch (Number(permitId)) {
    case 1:
      return 'Planning Department';
    case 2:
    case 4:
      return 'Engineering Department';
    case 5:
    case 6:
    case 7:
    case 8:
      return 'Clerk Department';
    case 9:
      return 'Building or Construction Department';
    case 10:
      return 'Department of Health or Animal Control';
    case 12:
      return 'Department of Health and Mental Hygiene';
    default:
      return '';
  }
};

export const buildPermitApplicationPath = ({
  townshipId,
  permitId,
  applicationId,
  view = 'list'
}: {
  townshipId: string | number;
  permitId: string | number;
  applicationId?: string | number;
  view?: 'list' | 'view';
}): string | null => {
  const departmentName = getDepartmentNameByPermitId(Number(permitId));
  if (!departmentName || townshipId == null || townshipId === '') {
    return null;
  }

  const base = `/${townshipId}/${departmentName}/${permitId}`;
  if (view === 'view' && applicationId != null && applicationId !== '') {
    return `${base}/view-application/${applicationId}`;
  }
  return `${base}/application-list`;
};
